// NPM Packages
import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import store from "store2";

// Components
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import NewDelivery from "./pages/NewDelivery";
import Delivery from "./pages/Delivery";
import EditDelivery from "./pages/EditDelivery";
import AddRider from "./pages/AddRider";
import Riders from "./pages/Riders";
import RiderLocations from "./pages/RiderLocations";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AccessControl from "./pages/AccessControl";

// Reports
import TotalDeliveries from "./pages/reports/TotalDeliveries";
import AvgOutdoorDeliveryTime from "./pages/reports/AvgOutdoorDeliveryTime";
import AvgAtTheDoorTime from "./pages/reports/AvgAtTheDoorTime";
import DeliveriesSummary from "./pages/reports/DeliveriesSummary";
import AvgDeliveryTime from "./pages/reports/AvgDeliveryTime";
import OrdersOutdoorDeliveryTime from "./pages/reports/OrdersOutdoorDeliveryTime";
import OrdersAtTheDoorDeliveryTime from "./pages/reports/OrdersAtTheDoorDeliveryTime";
import Transactions from "./pages/reports/Transactions";
import Rate from "./pages/Rate";
import FYFReport from "./pages/reports/FYFReport";

// Helpers
import hasAccess from "./helpers/hasAccess";
import PickupType from "./pages/PickupType";
import DeliveryPublic from "./pages/DeliveryPublic";

function PrivateRoute({ component: Component, module, ...rest }) {
  const authed = !!store.session.get("token");

  if (module && !hasAccess(module)) {
    if (rest.path === "/") {
      store.session.remove("token");
      store.session.remove("user");

      return (
        <Route
          {...rest}
          render={(props) => (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          )}
        />
      );
    } else {
      return (
        <Route
          {...rest}
          render={(props) => (
            <Redirect to={{ pathname: "/", state: { from: props.location } }} />
          )}
        />
      );
    }
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        authed === true ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }
    />
  );
}

function AdminOnlyRoute({ component: Component, ...rest }) {
  const user = store.session.get("user");

  return (
    <Route
      {...rest}
      render={(props) =>
        user.role.name !== "admin" ? (
          <Redirect to="/" />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
}

function GuestOnlyRoute({ component: Component, ...rest }) {
  const authed = !!store.session.get("token");

  return (
    <Route
      {...rest}
      render={(props) =>
        authed === true ? <Redirect to="/" /> : <Component {...props} />
      }
    />
  );
}

function App() {
  return (
    <Router>
      <Switch>
        <PrivateRoute
          path="/"
          exact
          component={Dashboard}
          module="view_dashboard"
        />
        <PrivateRoute
          path="/riders"
          exact
          component={Riders}
          module="view_riders"
        />
        <PrivateRoute
          path="/riders/add"
          exact
          component={AddRider}
          module="add_rider"
        />
        <PrivateRoute
          path="/rider-locations"
          exact
          component={RiderLocations}
          module="view_rider_locations"
        />
        <AdminOnlyRoute path="/access-control" component={AccessControl} />

        {/* Reports */}
        <PrivateRoute
          path="/reports/total-deliveries"
          component={TotalDeliveries}
          module="view_total_deliveries_reports"
        />
        <PrivateRoute
          path="/reports/average-delivery-time"
          component={AvgDeliveryTime}
          module="view_average_delivery_time_reports"
        />
        <PrivateRoute
          path="/reports/average-outdoor-delivery-time"
          component={AvgOutdoorDeliveryTime}
          module="view_average_outdoor_delivery_time_reports"
        />
        <PrivateRoute
          path="/reports/orders-outdoor-delivery-time"
          component={OrdersOutdoorDeliveryTime}
          module="view_outdoor_delivery_time_per_order_reports"
        />
        <PrivateRoute
          path="/reports/orders-at-the-door-delivery-time"
          component={OrdersAtTheDoorDeliveryTime}
          module="view_at_the_door_delivery_time_per_order_reports"
        />
        <PrivateRoute
          path="/reports/average-at-the-door-time"
          component={AvgAtTheDoorTime}
          module="view_average_at_the_door_time_reports"
        />
        <PrivateRoute
          path="/reports/deliveries-summary"
          component={DeliveriesSummary}
          module="view_deliveries_summary_reports"
        />
        <PrivateRoute
          path="/reports/transactions"
          component={Transactions}
          module="view_transactions_reports"
        />
        <PrivateRoute
          path="/reports/fyf-tracker"
          component={FYFReport}
          module="view_fyf_tracker_reports"
        />

        <PrivateRoute path="/delivery/add" exact component={NewDelivery} />
        <PrivateRoute path="/delivery/:uuid" exact component={Delivery} />
        <PrivateRoute
          path="/delivery/edit/:uuid"
          exact
          component={EditDelivery}
        />

        {/* Public routes */}
        <Route path="/pickup/:uuid" component={PickupType} />
        <Route path="/delivery/:uuid/public" component={DeliveryPublic} />
        <Route path="/login" component={Login} />
        <Route path="/privacy" component={PrivacyPolicy} />

        {/* Guest Only routes */}
        <GuestOnlyRoute path={["/rate/:uuid", "/rate"]} component={Rate} />
      </Switch>
    </Router>
  );
}

export default App;
